module.exports = __webpack_public_path__ + "static/WEDDING E&M-300-0008f53c5a5941c9895fa91b306c30b5.jpg";